import React from 'react';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Button } from 'antd';
import IconEmpty from '../../assets/Images/icons/empty';
import DCDPOService from '../../services/DCDPO.service';
import { ROUTER } from '../../constants/router';
import parse from 'html-react-parser';
import usePermission from '../../hooks/usePermission';

const DCDPOView = () => {
    const { t } = useTranslation();
    let navigate = useNavigate();

    const [response, setResponse] = useState();

    const getDCDPO = async () => {
        try {
            const { data } = await DCDPOService.getDCDPO();
            const item = data?.resultData;
            setResponse(item);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        getDCDPO();
    }, []);

    const { isAuditor, isUser } = usePermission();

    return (
        <div>
            <div className="title">{t('common.DC&DPO')}</div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {t('common.Configuration')} /
                </span>
                <span> {t('dcdpo.dcdpo')} </span>
            </div>
            <div className="bg-white rounded-xl px-14 py-8 my-4 col-span-2">
                <div className="pb-2 border-b-3 border-[#F4F6FC]">
                    <div className="flex space-x-2 items-center justify-between">
                        <div className="grid grid-cols-1">
                            <div className="text-xl font-[500]">
                                {t('common.DC&DPO')}
                            </div>
                            <div>{t('dcdpo.dcdposub')}</div>
                        </div>
                        <div>
                            {response ? (
                                <Button
                                    disabled={isAuditor || isUser}
                                    type="default"
                                    className="w-32 text-[#7B67FB] border-[#7B67FB]"
                                    onClick={() => {
                                        navigate(
                                            `${ROUTER.CONFIGURATION.DC_DPO}/edit`
                                        );
                                    }}
                                    size="large"
                                >
                                    {t('common.Edit')}
                                </Button>
                            ) : (
                                <Button
                                    className="w-32 p-0"
                                    disabled={isAuditor || isUser}
                                    size="large"
                                    type="primary"
                                    onClick={() => {
                                        navigate(
                                            `${ROUTER.CONFIGURATION.DC_DPO}/create`
                                        );
                                    }}
                                >
                                    {t('dcdpo.add')}
                                </Button>
                            )}
                        </div>
                    </div>
                </div>
                <div className="pt-2">
                    {response ? (
                        <div>
                            <Card data={response} />
                        </div>
                    ) : (
                        <div className="h-[65vh] grid items-center justify-center">
                            <div className="-mt-16">
                                <IconEmpty />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

const Card = ({ data }) => {
    const { t, i18n } = useTranslation();
    return (
        <div className="flex flex-col space-y-4 my-4 break-all">
            <div className="grid grid-cols-12">
                <div className="bg-[#F4F6FC] rounded-xl px-5 py-2.5 col-span-7">
                    <div className="font-[600] text-base text-[#7B67FB]">
                        {t('dcdpo.DataController')}
                    </div>
                    <div
                        className={`${
                            !data?.nameDPOTh && !data?.addressTh ? 'hidden' : ''
                        }`}
                    >
                        <div className="text-base font-[600]">
                            {i18n.language === 'en' ? 'Thai' : 'ภาษาไทย'}
                        </div>
                        <div>
                            <ul
                                className="list-outside"
                                style={{ paddingInlineStart: '35px' }}
                            >
                                {data?.nameDPOTh && (
                                    <li className="list-disc whitespace-pre-line">
                                        {data?.nameDPOTh || '-'}
                                    </li>
                                )}
                                {data?.addressTh && (
                                    <li className="list-disc whitespace-pre-line">
                                        {parse(data?.addressTh || '-')}
                                    </li>
                                )}
                            </ul>
                        </div>
                    </div>
                    <div
                        className={`${
                            !data?.nameDPOEn && !data?.addressEn ? 'hidden' : ''
                        }`}
                    >
                        <div className="text-base font-[600]">
                            {i18n.language === 'en' ? 'English' : 'ภาษาอังกฤษ'}
                        </div>
                        <div>
                            <ul
                                className="list-outside"
                                style={{ paddingInlineStart: '35px' }}
                            >
                                {data?.nameDPOEn && (
                                    <li className="list-disc whitespace-pre-line">
                                        {data?.nameDPOEn || '-'}
                                    </li>
                                )}
                                {data?.addressEn && (
                                    <li className="list-disc whitespace-pre-line">
                                        {parse(data?.addressEn || '-')}
                                    </li>
                                )}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div className="grid grid-cols-12">
                <div className="bg-[#F4F6FC] rounded-xl px-5 py-2.5 col-span-7">
                    <div className="font-[600] text-base text-[#7B67FB]">
                        {t('dcdpo.Contact')}
                    </div>
                    <div className="font-[600] text-tiny my-2">
                        {t('dcdpo.DataProtectionOfficer')}
                    </div>
                    <div className={`${!data?.staffNameDPOTh ? 'hidden' : ''}`}>
                        <div className="text-base font-[600]">
                            {i18n.language === 'en' ? 'Thai' : 'ภาษาไทย'}
                        </div>
                        <div>
                            <ul
                                className="list-outside"
                                style={{ paddingInlineStart: '35px' }}
                            >
                                {data?.staffNameDPOTh && (
                                    <li className="list-disc whitespace-pre-line">
                                        {parse(data?.staffNameDPOTh || '-')}
                                    </li>
                                )}
                            </ul>
                        </div>
                    </div>
                    <div className={`${!data?.staffNameDPOEn ? 'hidden' : ''}`}>
                        <div className="text-base font-[600]">
                            {i18n.language === 'en' ? 'English' : 'ภาษาอังกฤษ'}
                        </div>
                        <div>
                            <ul
                                className="list-outside"
                                style={{ paddingInlineStart: '35px' }}
                            >
                                {data?.staffNameDPOEn && (
                                    <li className="list-disc whitespace-pre-line">
                                        {parse(data?.staffNameDPOEn || '-')}
                                    </li>
                                )}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DCDPOView;
